import { useParams } from 'react-router-dom';

export default function useIsEdit() {
	const { auth0Id = '' } = useParams<{ auth0Id: string }>();
	return !!auth0Id;
}
